const generateRouteTitle = function generateRouteTitle(title) {
  return this.$t(`route.${title}`); // $t :this method from vue-i18n ,inject in @/lang/index2.js
};
const generateMessage = function generateMessage(message) {
  return this.$t(`message.${message.replace('/', '.')}`); // $t :this method from vue-i18n ,inject in @/lang/index2.js
};
const generatePluralizedMessage = function generatePluralizedMessage(
  message,
  number
) {
  return this.$tc(`message.${message.replace('/', '.')}`, number); // $t :this method from vue-i18n ,inject in @/lang/index2.js
};
const generateMessageFunction = function generateMessageFunction(
  message,
  value
) {
  return this.$t(`message.${message}`, value); // $t :this method from vue-i18n ,inject in @/lang/index2.js
};
export {
  generateRouteTitle,
  generateMessageFunction,
  generateMessage,
  generatePluralizedMessage,
};
